module.exports = __webpack_public_path__ + "img/house-img1.2223d0c6.jpg";